<template>
    <div class="notice">
        <car-headerbar :title="title" :isCustomLeft="isCustomLeft"/>
        <me-tabs class="notice-content" v-model="active">
            <me-tab title="通知内容">
                <noticeContent v-if="active===0"></noticeContent>
            </me-tab>
            <me-tab title="发送记录">
                <noticeProcess v-if="active===1"></noticeProcess>
            </me-tab>
        </me-tabs>
    </div>
</template>
<script>
import { removeClass2 } from '@/util/status-util'
import browser from '@/util/browser'
import noticeContent from './notice_content.vue'
import noticeProcess from './notice_process.vue'

export default {
    name: 'notice',
    data() {
        return {
            title: '通知',
            isCustomLeft: false,
            active: 0,
        }
    },
    components: { noticeContent, noticeProcess },
    created() {
        if (this.$route.query.active) {
            this.active = Number(this.$route.query.active)
        }
        removeClass2('body', 'loading')
        const { guaguaApp } = browser
        this.isCustomLeft = guaguaApp
    },
}
</script>
<style scoped lang="scss">
    .notice{
        min-height: 100%;
    }
    ::v-deep .me-tab--active{
        font-size: 0.42667rem;
    }
    ::v-deep .me-tabs__line{
        width: 1.7rem;
    }
    ::v-deep .me-popup--bottom{
        border-radius: .2rem .2rem 0 0;
    }
</style>
